import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

export enum Mode {
  Create = 'create',
  Update = 'update',
  View = 'view',
  Draft = 'draft',
  Review = 'review',
}

export const createResolver = {
  provide: 'createResolver',
  useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    Mode.Create,
};

export const updateResolver = {
  provide: 'updateResolver',
  useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    Mode.Update,
};

export const viewResolver = {
  provide: 'viewResolver',
  useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    Mode.View,
};

export const draftResolver = {
  provide: 'draftResolver',
  useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    Mode.Draft,
};

export const reviewResolver = {
  provide: 'reviewResolver',
  useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    Mode.Review,
};
